import { inject, injectable } from 'inversify';
import {
  GetUserPaymentMethodsParams,
  GetUserPaymentMethodsResponse,
  PaymentMethodServiceInterface,
} from './PaymentMethodsService.types';
import { backendUrl } from 'src/config';
import HttpClient from 'src/features/http';

@injectable()
class PaymentMethodService implements PaymentMethodServiceInterface {
  @inject(HttpClient) private readonly client!: HttpClient;

  public getUserPaymentMethods({
    userId,
    accessToken,
  }: GetUserPaymentMethodsParams) {
    return this.client
      .getClient()
      .get<GetUserPaymentMethodsResponse>(`/users/${userId}/payment-methods/`, {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${accessToken}` },
      });
  }
}

export default PaymentMethodService;
